import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

const AboutUs = ({ pages }) => {
  return (
    <div className='four columns'>
      <div>
        <h1 className='header top-line'>{I18n.t('layouts.footer.about')}</h1>
        {pages.map((pagePerColumn, index) => (
          <ul key={index} className='half-menu inner'>
            {pagePerColumn.map(page => (
              <li key={page.title}>
                <a href={page.link}>{page.title}</a>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  )
}

AboutUs.propTypes = {
  pages: PropTypes.array
}

export default AboutUs
